import type { Child, ElNode, Instruction } from '@crown/framework/ir';
import type { BrandColor } from '../types';
import template from './card.tsrx';

export interface CardProps {
  id?: string;
  /** Text, an element, or instructions: a page built from instructions passes its own markup. */
  title?: Child;
  content: Child;
  footer?: Child;
  variant?: BrandColor;
  extraClasses?: string | string[];
}

export interface CardTemplateProps {
  readonly id: string | null;
  readonly classes: string;
  readonly title: Child | null;
  readonly content: Child;
  readonly footer: Child | null;
}

const CardTemplate: (props: CardTemplateProps) => Instruction = template;

const CARD_UTILITY = 'card';

export function cardClasses({
  variant,
  extraClasses,
}: Pick<CardProps, 'variant' | 'extraClasses'>): string {
  const classes = [CARD_UTILITY];
  if (variant) classes.push(variant);
  if (extraClasses)
    classes.push(
      ...(Array.isArray(extraClasses) ? extraClasses : [extraClasses]),
    );
  return classes.join(' ');
}

export function Card(props: CardProps): ElNode {
  const { id, title, content, footer } = props;
  const node = CardTemplate({
    id: id ?? null,
    classes: cardClasses(props),
    title: title ?? null,
    content,
    footer: footer ?? null,
  });
  if (node.t !== 'el') throw new Error('Card renders one element');
  return node;
}
